import classNames from "classnames";
import React from "react";

/**
 * @component 설정 페이지 섹션 타이틀
 * @description 섹션의 제목과 부제목, 추가적인 자식 요소를 표시하는 UI 컴포넌트.
 * @param {SectionTitleProps} props - 컴포넌트에 전달되는 props.
 * @param {React.ReactNode} props.title - 섹션의 주 제목.
 * @param {React.ReactNode} [props.subTitle] - 섹션의 부제목. 있을 경우에만 표시됩니다.
 * @param {string} [props.className] - div 최상위 요소에 추가할 CSS 클래스.
 * @param {React.ReactNode} [props.children] - 제목 영역에 추가적으로 렌더링할 자식 요소들.
 * @param {boolean} [props.addBottomBorder] - 하단 보더 추가 여부.
 */

interface SectionTitleProps {
  title: React.ReactNode;
  subTitle?: React.ReactNode;
  className?: string;
  children?: React.ReactNode;
  addBottomBorder?: boolean;
}

export const SectionTitle: React.FC<SectionTitleProps> = ({
  title,
  subTitle,
  className,
  addBottomBorder,
  children,
}) => {
  return (
    <div
      className={classNames(
        "!flex w-full relative items-center",
        {
          "justify-between": children,
        },
        {
          "pt-4 pb-[6px]": addBottomBorder,
        }
      )}
      style={{
        borderBottom: addBottomBorder ? "2px solid #000" : "none",
      }}
    >
      <div className={classNames("flex items-baseline", className)}>
        <h4 className="!text-[21px] !text-black !pb-1">{title}</h4>
        {subTitle && <span className="pl-2 text-[15px] text-text-tertiary">{subTitle}</span>}
      </div>
      {children && <>{children}</>}
    </div>
  );
};
